import { render, staticRenderFns } from "./PrivilegeCategoryDetail.vue?vue&type=template&id=e804c568&scoped=true&"
import script from "./PrivilegeCategoryDetail.vue?vue&type=script&lang=js&"
export * from "./PrivilegeCategoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegeCategoryDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PrivilegeCategoryDetail.vue?vue&type=style&index=1&id=e804c568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e804c568",
  null
  
)

export default component.exports